const TABS = [
  { id: 'dashboard',    label: 'Home',     icon: '◐' },
  { id: 'transactions', label: 'Activity', icon: '↕' },
  { id: 'forecast',     label: 'Forecast', icon: '◇' },
  { id: 'trends',       label: 'Trends',   icon: '◢' },
  { id: 'manage',       label: 'Manage',   icon: '☰' },
  { id: 'settings',     label: 'Settings', icon: '⚙' },
];

export default function NavBar({ active, onChange }) {
  return (
    <nav className="bottom-nav" role="tablist" aria-label="Main">
      {TABS.map(t => (
        <button
          key={t.id}
          className={active === t.id ? 'active' : ''}
          onClick={() => onChange(t.id)}
          role="tab"
          aria-selected={active === t.id}
        >
          <span className="icon">{t.icon}</span>
          <span>{t.label}</span>
        </button>
      ))}
    </nav>
  );
}
